import { X } from 'lucide-react';
import { MouseEvent } from 'react';
import { FilterTestIds } from '../../../../../utils/testIds/Filter.testIds';
import { FilterProps } from '../../../../Crud/filters/sharedBetweenFilters/types';
import { IFilterHelperFactory } from '../../../factories/filter-factory.types';
import FilterChip from '../../FilterChip/FilterChip';
import useSelectedFilterChip from './hooks/useSelectedFilterChip';

interface SelectedFilterChipProps {
  factory: IFilterHelperFactory;
  filter: FilterProps;
  onClick: (event: MouseEvent<HTMLElement>, filter: FilterProps) => void;
}

const SelectedFilterChip = ({ factory, filter, onClick }: SelectedFilterChipProps) => {
  const { primaryLabel, secondaryLabel, title, isLoading, onClear, removeAriaLabel } =
    useSelectedFilterChip({
      factory,
      filter,
    });

  return (
    <FilterChip
      title={title}
      isLoading={isLoading}
      primaryLabel={primaryLabel}
      secondaryLabel={secondaryLabel}
      testId={`${FilterTestIds.CHIP_PREFIX}${filter.title}`}
      onLabelClick={(event) => onClick(event, filter)}
      secondAction={{ icon: X, onClick: onClear, ariaLabel: removeAriaLabel }}
    />
  );
};

export default SelectedFilterChip;
